import { Lightning } from "@lightningjs/sdk";
import { Card } from "../base/Card";
import { FOCUS_TRANSITION } from "../base/focus";
import { WATCH_PANEL_WIDTH } from "./styles";
/** A looping list with the selected card anchored in the centre. */
export class CentredClipsRow extends Lightning.Component {
    static _template() {
        return {
            w: WATCH_PANEL_WIDTH,
            h: Card.H,
            clipping: true,
            List: {
                type: Lightning.components.ListComponent,
                w: WATCH_PANEL_WIDTH,
                h: Card.H,
                horizontal: true,
                // In ListComponent, false loops continuously; true jumps at the ends.
                roll: false,
                itemSize: Card.W + this.GAP,
                viewportScrollOffset: 0.5,
                itemScrollOffset: Card.W / (2 * (Card.W + this.GAP)),
                scrollTransition: { duration: 0.25, timingFunction: "ease-out" },
            },
        };
    }
    get selectedIndex() {
        const list = this.tag("List");
        return list.length ? list.realIndex : 0;
    }
    set items(items) {
        const list = this.tag("List");
        list.items = items.map((item) => (Object.assign({ type: Card }, item)));
        list.setIndex(Math.min(2, Math.max(0, items.length - 1)), true);
        this.updateSelection(false);
        this._refocus();
    }
    _getFocused() {
        var _a;
        return (_a = this.tag("List").element) !== null && _a !== void 0 ? _a : this;
    }
    _handleLeft() {
        this.move(-1);
        return true;
    }
    _handleRight() {
        this.move(1);
        return true;
    }
    move(direction) {
        const list = this.tag("List");
        if (list.length < 2)
            return;
        list.setIndex(list.index + direction);
        this.updateSelection(true);
        this._refocus();
    }
    updateSelection(animate) {
        this.tag("List").items.forEach((card, index) => {
            const alpha = index === this.selectedIndex ? 1 : 0.5;
            if (animate)
                card.setSmooth("alpha", alpha, FOCUS_TRANSITION);
            else
                card.patch({ alpha });
        });
    }
}
CentredClipsRow.GAP = 40;
export default CentredClipsRow;
//# sourceMappingURL=CentredClipsRow.js.map